import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@design-system';

import { Loader2 } from 'lucide-react';

interface PartnerContactExclusionConfirmDialogProps {
  open: boolean;
  email: string;
  isAdding: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

// Confirms adding someone to the contact-exclusion list. This is destructive: it not only hides them
// from the partner contacts list, it revokes every existing connection where they are the contact —
// tearing down those links and clawing back the clients already shared with them. It can't be undone
// by removing them from the list later.
export function PartnerContactExclusionConfirmDialog({
  open,
  email,
  isAdding,
  onConfirm,
  onCancel,
}: PartnerContactExclusionConfirmDialogProps) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={isOpen => !isOpen && !isAdding && onCancel()}
    >
      <AlertDialogContent className="max-w-lg">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-primary-dark">Exclude {email}?</AlertDialogTitle>
          <AlertDialogDescription className="text-foreground">
            {email} will be removed from the Distribution Partners contacts list for every advisor,
            and any existing connections and clients already shared with them will be revoked. This
            can't be undone — removing them from the list later will not restore the revoked
            connections or shared clients.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <Button
            variant="outline"
            onClick={onCancel}
            disabled={isAdding}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isAdding}
          >
            {isAdding ? (
              <>
                <Loader2 className="animate-spin" />
                Excluding…
              </>
            ) : (
              'Exclude'
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
